import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import StaticBanner from '../../../components/elements/StaticBanner';
import BannerImg from '../../../../public/assets/images/BannersFiles/23.jpg';
import { Link } from 'react-router-dom';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';

const JudeGifts = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const { t } = useTranslation();
  const { pathname } = useLocation();


  useEffect(() => {
    PageHitCountApi(pathname, 0);
    localStorage.setItem('isHome', true);
  }, []);



  return (
    <>
      <div className="">
        <StaticBanner BannerImg={BannerImg} en_US={'Jude Gifts'} arabic={false} />
        <section
          className={`px-10 sm:h-90 flex xl:flex-row flex-col pb-5 sm:px-20 ${isActive ? 'text-right' : 'text-left'}`}
        >
          <img src={`/assets/images/1234.png`} className=" md:max-w-screen-sm" alt="" />
          <div className="pt-2 xl:px-10 flex flex-col justify-center items-center align-middle ">
            {/* <h2 className={`text-black text-4xl flex font-bold py-6  ${isActive ? 'justify-right ' : 'text-left '}`}>من نحن </h2> */}
            <h4
              className={`text-customgreen  flex sm:text-2xl items-center text-justify leading-10  `}
            >
              {isActive
                ? ` تمكنك خدمة هدايا من إهداء مشاريع أو صدقات لمن تحب بإرسال بطاقة إهداء مميزة في عدد من المناسبات الخاصة (
            زواج, ولادة, تخرج, شفاء, أعياد) من خلال الرسائل النصية أو البريد الإلكتروني.`
                : `The "Gifts of Goodness" service allows you to gift projects or charities to loved ones by sending a special gift card on various special occasions (weddings, births, graduations, recoveries, holidays) via SMS or email.`}
            </h4>
            <Link to={'/Gift'}>
              <button
                type="submit"
                className="text-white mx-1 mt-3 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-3 py-2.5 text-center"
              >
                {t('Jude Gifts')}
              </button>{' '}
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default JudeGifts;
